const listRouterFn = () => {
  let array = [];

  // for (let i = 0; i < 24; i++) {
  //   let obj1 = {
  //     path: "/activityAnswer/question" + i,
  //     name: "/activityAnswer/question" + i,
  //     meta: {
  //       title: "答题",
  //     },
  //   };
  //   obj1.component = (resolve) =>
  //     require([`@/views/activityAnswer/question.vue`], resolve);
  //   let obj2 = {
  //     path: "/activityAnswer/lucky" + i,
  //     name: "/activityAnswer/lucky" + i,
  //     meta: {
  //       title: "答题",
  //     },
  //   };
  //   obj2.component = (resolve) =>
  //     require([`@/views/activityAnswer/lucky.vue`], resolve);
  //   // console.log(array);
  //   array = array.concat([obj1, obj2]);
  // }
  return array;
};
export const listRouterArr = listRouterFn();
